import React, { memo, useEffect } from "react";
// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Popup } from "@swiggy-private/dls-web-core/dist/components/Popup";
import { Button } from "@swiggy-private/dls-web-core/dist/components/Button";
// styles
import { WrapperContainer, CTAContainer, PrimaryCTAButton, SubHeadingText, SecondaryCTAButton } from "./styles";
// helpers
import { isEmpty } from "@swiggy-private/js-utils";
// types
import { MROCouponClashPopup } from "@swiggy-private/cart-types";

const TEXTS = {
    CANCEL: "Cancel",
    APPLY: "Apply",
};

export const MROApplyCouponPopup = ({
    enabled,
    title,
    subtitle,
    secondaryCta,
    primaryCta,
    impressionEvent,
}: MROCouponClashPopup) => {
    const shouldShow =
        enabled && !isEmpty(title) && !isEmpty(subtitle) && !isEmpty(secondaryCta) && !isEmpty(primaryCta);

    useEffect(() => {
        if (shouldShow && impressionEvent) {
            impressionEvent();
        }
    }, [shouldShow, impressionEvent]);

    if (!shouldShow) {
        return null;
    }

    return (
        <Popup isOpen hasCustomPadding>
            <WrapperContainer>
                <Text variant="V2.subheading1.neutral.black" color="text_Highest_Emphasis">
                    {title}
                </Text>
                <SubHeadingText variant="V2.body2.neutral.regular" color="text_Med_Emphasis">
                    {subtitle}
                </SubHeadingText>
                <CTAContainer>
                    <SecondaryCTAButton>
                        <Button variant="secondary" onClick={secondaryCta.onClick}>
                            {secondaryCta.text ?? TEXTS.CANCEL}
                        </Button>
                    </SecondaryCTAButton>
                    <PrimaryCTAButton>
                        <Button variant="primary" onClick={primaryCta.onClick}>
                            {primaryCta.text ?? TEXTS.APPLY}
                        </Button>
                    </PrimaryCTAButton>
                </CTAContainer>
            </WrapperContainer>
        </Popup>
    );
};

export default memo(MROApplyCouponPopup);
